import React, { useState } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import DataTable from "react-data-table-component";

//Components
import Layout from "../../../../Layout/Layout";

import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";

// import SuccessModal from "../../../../Components/Modal/supplier_app/SuccessModal";
import { InputField } from "../../../../Components/formElements/InputField";
import RichTextEditor from "../../../../Components/Editor/RichTextEditor";

const FinancePriceBreakDownCreation = () => {
  // const dispatch = useDispatch();

  localStorage.setItem("menu", "");
  localStorage.setItem("submenu", "");

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);

  const [formInputs, setFormInputs] = useState({
    dateJobEnteredSales: "",
    dateJobEnteredFirm: "",
    salesPersonCode: "",
    customer: "",
    customerNo: "",
    endUser: "",
    nonIdenticalBuildings: "",
    totalBuildings: "",
    roofArea: "",
    paymentTermsLC: "",
    paymentTermsBG: "",
    paymentTermsOthers: "",
    ccoChangeOrderNo: "",
    engineeringComplexity: "",
    approvalEngineering: "",
    productionEngineering: "",
    quoteNo: "",
    templateBasic: "",
    sellingOffice: "",
    receivingOffice: "",
    receivingTerritory: "",
    erector: "",
    mezzArea: "",
    estimatingEngineer: "",
    eOMSupervisor: "",
    eOMManager: "",
    approvalDate: "",
    remarks: "",
  });

  /* style start */
  // const tableStyle = {
  //   borderCollapse: "collapse",
  //   width: "100%",
  //   fontFamily: "Arial, sans-serif",
  // };

  // const thStyle = {
  //   border: "1px solid #ddd",
  //   textAlign: "left",
  //   padding: "8px",
  //   backgroundColor: "#f2f2f2",
  //   fontWeight: "bold",
  // };

  // const tdStyle = {
  //   border: "1px solid #ddd",
  //   textAlign: "left",
  //   padding: "8px",
  // };

  // const evenRowStyle = {
  //   backgroundColor: "#f9f9f9",
  // };
  /* style end */

  const initialRows = [
    {
      id: "1A",
      description: "Frames: Built up / Hot rolled",
      weight: 0,
      bookPrice: 0,
      sellingPrice: 0,
      soldRate: 0,
      ed: 0,
      vat: 0,
      serviceTax: 0,
      igst: 0,
      cgst: 0,
      sgst: 0,
      discount: 0,
      by: "",
    },
    {
      id: "1B",
      description: "Cold Formed Sections: Purlins, Girts, Eave Strut",
      weight: 0,
      bookPrice: 0,
      sellingPrice: 0,
      soldRate: 0,
      ed: 0,
      vat: 0,
      serviceTax: 0,
      igst: 0,
      cgst: 0,
      sgst: 0,
      discount: 0,
      by: "",
    },
    {
      id: "1C",
      description: "Sundry Parts: Scab plates, Shim plates, etc.",
      weight: 0,
      bookPrice: 0,
      sellingPrice: 0,
      soldRate: 0,
      ed: 0,
      vat: 0,
      serviceTax: 0,
      igst: 0,
      cgst: 0,
      sgst: 0,
      discount: 0,
      by: "",
    },
    {
      id: "1D",
      description: "Sheets: All Types and all Finishes",
      weight: 0,
      bookPrice: 0,
      sellingPrice: 0,
      soldRate: 0,
      ed: 0,
      vat: 0,
      serviceTax: 0,
      igst: 0,
      cgst: 0,
      sgst: 0,
      discount: 0,
      by: "",
    },
    {
      id: "1E",
      description: "Trims: Gutters, Downspouts, Trims, flashings, etc.",
      weight: 0,
      bookPrice: 0,
      sellingPrice: 0,
      soldRate: 0,
      ed: 0,
      vat: 0,
      serviceTax: 0,
      igst: 0,
      cgst: 0,
      sgst: 0,
      discount: 0,
      by: "",
    },
    {
      id: "1F",
      description: "Tempcon Panels: TCSP, TCCTP & TCMP",
      weight: 0,
      bookPrice: 0,
      sellingPrice: 0,
      soldRate: 0,
      ed: 0,
      vat: 0,
      serviceTax: 0,
      igst: 0,
      cgst: 0,
      sgst: 0,
      discount: 0,
      by: "",
    },
    {
      id: "1G",
      description:
        "Space Frame: Chord, Trims, Hot Roll Tubes & Misc. Connections",
      weight: 0,
      bookPrice: 0,
      sellingPrice: 0,
      soldRate: 0,
      ed: 0,
      vat: 0,
      serviceTax: 0,
      igst: 0,
      cgst: 0,
      sgst: 0,
      discount: 0,
      by: "",
    },
    {
      id: "1H",
      description: "Open Web Joist: Mezz Joists, Roof purlins, beams, etc.",
      weight: 0,
      bookPrice: 0,
      sellingPrice: 0,
      soldRate: 0,
      ed: 0,
      vat: 0,
      serviceTax: 0,
      igst: 0,
      cgst: 0,
      sgst: 0,
      discount: 0,
      by: "",
    },
  ];

  const [rows, setRows] = useState(initialRows);

  const handleChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  const handleSave = () => {
    // eslint-disable-next-line
    const obj = {
      ...formInputs,
    };
    // console.log(">>obj", obj);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} lg={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col>
                <Col xs={12} md={12} lg={12}>
                  <h2 className="mainTitle">FINANCE PRICE BREAKDOWN</h2>
                  <p className="subText">Finance Price Breakdown Details</p>
                </Col>
              </Col>
            </Row>

            <hr />

            {/* <Row className="mb-4">
              <Col xs={12} md={2} lg={2} className="d-flex justify-content-end">
                <>
                  <button className="btnBack">save</button>
                </>
              </Col>
            </Row> */}

            {/*  details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">FP</span>
                    </Col>

                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle">
                        {" "}
                        FINANCE PRICE BREAKDOWN{" "}
                      </span>
                      <span className="subHeaderTitle">
                        FINANCE PRICE BREAKDOWN{" "}
                      </span>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Job No"
                                name="jobNo"
                                id="jobNo"
                                value={formInputs?.jobNo}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Date Job Entered in MFS"
                                type="date"
                                name="dateJobEnteredMFS"
                                id="dateJobEnteredMFS"
                                value={formInputs?.dateJobEnteredMFS}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Date Job Entered in Sales"
                                name="dateJobEnteredSales"
                                type="date"
                                id="dateJobEnteredSales"
                                value={formInputs?.dateJobEnteredSales}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Date Job Entered Firm"
                                type="date"
                                name="dateJobEnteredFirm"
                                id="dateJobEnteredFirm"
                                value={formInputs?.dateJobEnteredFirm}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Sales Person Code"
                                name="salesPersonCode"
                                id="salesPersonCode"
                                value={formInputs?.salesPersonCode}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Customer"
                                name="customer"
                                id="customer"
                                value={formInputs?.customer}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Customer No"
                                name="customerNo"
                                id="customerNo"
                                value={formInputs?.customerNo}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="End User"
                                name="endUser"
                                id="endUser"
                                value={formInputs?.endUser}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="No. of non identical Bldgs"
                                name="nonIdenticalBuildings"
                                id="nonIdenticalBuildings"
                                value={formInputs?.nonIdenticalBuildings}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total no of Buildings"
                                name="totalBuildings"
                                id="totalBuildings"
                                value={formInputs?.totalBuildings}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Roof Area (m²)"
                                name="roofArea"
                                id="roofArea"
                                value={formInputs?.roofArea}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Payment Terms - L/C"
                                name="paymentTermsLC"
                                id="paymentTermsLC"
                                value={formInputs?.paymentTermsLC}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Payment Terms - BG"
                                name="paymentTermsBG"
                                id="paymentTermsBG"
                                value={formInputs?.paymentTermsBG}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Payment Terms - Others (Specify)"
                                name="paymentTermsOthers"
                                id="paymentTermsOthers"
                                value={formInputs?.paymentTermsOthers}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Includes all CCO through Change Order No"
                                name="ccoChangeOrderNo"
                                id="ccoChangeOrderNo"
                                value={formInputs?.ccoChangeOrderNo}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Engineering Complexity"
                                name="engineeringComplexity"
                                id="engineeringComplexity"
                                value={formInputs?.engineeringComplexity}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Approval Engineering"
                                name="approvalEngineering"
                                id="approvalEngineering"
                                value={formInputs?.approvalEngineering}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Production Engineering"
                                name="productionEngineering"
                                id="productionEngineering"
                                value={formInputs?.productionEngineering}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Quote No"
                                name="quoteNo"
                                id="quoteNo"
                                value={formInputs?.quoteNo}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Template Basic"
                                name="templateBasic"
                                id="templateBasic"
                                value={formInputs?.templateBasic}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Selling Office"
                                name="sellingOffice"
                                id="sellingOffice"
                                value={formInputs?.sellingOffice}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Receiving Office"
                                name="receivingOffice"
                                id="receivingOffice"
                                value={formInputs?.receivingOffice}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Receiving Territory"
                                name="receivingTerritory"
                                id="receivingTerritory"
                                value={formInputs?.receivingTerritory}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Erector"
                                name="erector"
                                id="erector"
                                value={formInputs?.erector}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Mezz Area (m²)"
                                name="mezzArea"
                                id="mezzArea"
                                value={formInputs?.mezzArea}
                                onChange={onInputChange}
                              />
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/*  Table1  */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">MT</span>
                    </Col>

                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle">
                        {" "}
                        FINANCE PRICE BREAKDOWN TABLE{" "}
                      </span>
                      <span className="subHeaderTitle">
                        Finance Price Breakdown Table{" "}
                      </span>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          {/*Table*/}
                          <div className="accordion-body autoScroll">
                            <Row>
                              <Col xs={12} md={12} lg={12}>
                                <div className="generatedTable width-100">
                                  <table className="table-auto border-collapse w-full">
                                    <thead>
                                      <tr className="bg-gray-200">
                                        <th className="border p-1">Item No</th>
                                        <th className="border p-1">
                                          Description
                                        </th>
                                        <th className="border p-1">
                                          Weight (MT)
                                        </th>
                                        <th className="border p-1">
                                          Book Price (INR)
                                        </th>
                                        <th className="border p-1">
                                          Selling Price (INR)
                                        </th>
                                        <th className="border p-1">
                                          Sold Rate (INR/MT)
                                        </th>
                                        <th className="border p-1">ED</th>
                                        <th className="border p-1">VAT</th>
                                        <th className="border p-1">
                                          Service TAX
                                        </th>
                                        <th className="border p-1">IGST</th>
                                        <th className="border p-1">CGST</th>
                                        <th className="border p-1">SGST</th>
                                        <th className="border p-1">
                                          Discount [%]
                                        </th>
                                        <th className="border p-1">By</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {rows.map((row, index) => (
                                        <tr key={row.id}>
                                          <td className="border p-1">
                                            {row.id}
                                          </td>
                                          <td className="border p-1">
                                            {row.description}
                                          </td>
                                          <td className="border p-1">
                                            <input
                                              type="number"
                                              value={row.weight}
                                              onChange={(e) =>
                                                handleChange(
                                                  index,
                                                  "weight",
                                                  e.target.value
                                                )
                                              }
                                              className="w-16 border p-0.5"
                                            />
                                          </td>
                                          <td className="border p-1">
                                            <input
                                              type="number"
                                              value={row.bookPrice}
                                              onChange={(e) =>
                                                handleChange(
                                                  index,
                                                  "bookPrice",
                                                  e.target.value
                                                )
                                              }
                                              className="w-16 border p-0.5"
                                            />
                                          </td>
                                          <td className="border p-1">
                                            <input
                                              type="number"
                                              value={row.sellingPrice}
                                              onChange={(e) =>
                                                handleChange(
                                                  index,
                                                  "sellingPrice",
                                                  e.target.value
                                                )
                                              }
                                              className="w-16 border p-0.5"
                                            />
                                          </td>
                                          <td className="border p-1">
                                            <input
                                              type="number"
                                              value={row.soldRate}
                                              onChange={(e) =>
                                                handleChange(
                                                  index,
                                                  "soldRate",
                                                  e.target.value
                                                )
                                              }
                                              className="w-16 border p-0.5"
                                            />
                                          </td>
                                          <td className="border p-1">
                                            <input
                                              type="number"
                                              value={row.ed}
                                              onChange={(e) =>
                                                handleChange(
                                                  index,
                                                  "ed",
                                                  e.target.value
                                                )
                                              }
                                              className="w-16 border p-0.5"
                                            />
                                          </td>
                                          <td className="border p-1">
                                            <input
                                              type="number"
                                              value={row.vat}
                                              onChange={(e) =>
                                                handleChange(
                                                  index,
                                                  "vat",
                                                  e.target.value
                                                )
                                              }
                                              className="w-16 border p-0.5"
                                            />
                                          </td>
                                          <td className="border p-1">
                                            <input
                                              type="number"
                                              value={row.serviceTax}
                                              onChange={(e) =>
                                                handleChange(
                                                  index,
                                                  "serviceTax",
                                                  e.target.value
                                                )
                                              }
                                              className="w-16 border p-0.5"
                                            />
                                          </td>
                                          <td className="border p-1">
                                            <input
                                              type="number"
                                              value={row.igst}
                                              onChange={(e) =>
                                                handleChange(
                                                  index,
                                                  "igst",
                                                  e.target.value
                                                )
                                              }
                                              className="w-16 border p-0.5"
                                            />
                                          </td>
                                          <td className="border p-1">
                                            <input
                                              type="number"
                                              value={row.cgst}
                                              onChange={(e) =>
                                                handleChange(
                                                  index,
                                                  "cgst",
                                                  e.target.value
                                                )
                                              }
                                              className="w-16 border p-0.5"
                                            />
                                          </td>
                                          <td className="border p-1">
                                            <input
                                              type="number"
                                              value={row.sgst}
                                              onChange={(e) =>
                                                handleChange(
                                                  index,
                                                  "sgst",
                                                  e.target.value
                                                )
                                              }
                                              className="w-16 border p-0.5"
                                            />
                                          </td>
                                          <td className="border p-1">
                                            <input
                                              type="number"
                                              value={row.discount}
                                              onChange={(e) =>
                                                handleChange(
                                                  index,
                                                  "discount",
                                                  e.target.value
                                                )
                                              }
                                              className="w-16 border p-0.5"
                                            />
                                          </td>
                                          <td className="border p-1">
                                            <input
                                              type="text"
                                              value={row.by}
                                              onChange={(e) =>
                                                handleChange(
                                                  index,
                                                  "by",
                                                  e.target.value
                                                )
                                              }
                                              className="w-20 border p-0.5"
                                            />
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Instructions 10*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RE</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Remarks</span>
                      <span className="subHeaderTitle">Remarks Section</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="p-4">
                      <Col xs={12} md={12} lg={12}>
                        <RichTextEditor
                          value={formInputs?.remarks}
                          // readOnly={true}
                          // onChange={handleTextChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* invoice details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AS</span>
                    </Col>

                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Approval Section</span>
                      <span className="subHeaderTitle">Approval Section</span>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Estimating Engineer"
                                name="estimatingEngineer"
                                id="estimatingEngineer"
                                value={formInputs?.estimatingEngineer}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="EOM Supervisor"
                                name="eOMSupervisor"
                                id="eOMSupervisor"
                                value={formInputs?.eOMSupervisor}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="EOM Manager"
                                name="eOMManager"
                                id="eOMManager"
                                value={formInputs?.eOMManager}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Approval Date"
                                name="approvalDate"
                                id="approvalDate"
                                type="date"
                                value={formInputs?.approvalDate}
                                onChange={onInputChange}
                              />
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <Row>
                <Col
                  xs={{ offset: 10, span: 2 }}
                  md={{ offset: 10, span: 2 }}
                  lg={{ offset: 10, span: 2 }}
                >
                  <button className="btnTable" onClick={handleSave}>
                    Submit
                  </button>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default FinancePriceBreakDownCreation;
